import Typography from "../../components/shared/typography";

export default function ThemedCheckbox({
  label,
  checked,
  onChange,
  id,
  error,
}: {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  id: string;
  error?: string;
}) {
  const containerBase =
    "flex items-center gap-3 py-2 px-3 rounded-md border cursor-pointer select-none transition-colors";
  const containerTheme = checked
    ? "border-terracotta-500 bg-terracotta-50"
    : "border-terracotta-200 hover:border-terracotta-300 bg-white";
  return (
    <label htmlFor={id} className={`${containerBase} ${containerTheme}`}>
      <input
        id={id}
        type="checkbox"
        className="h-4 w-4 rounded border-terracotta-300 accent-terracotta-600 text-terracotta-600 focus:ring-terracotta-500 focus:ring-offset-0 focus:outline-none outline-none"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="text-brown-900 text-sm">{label}</span>
      {error && (
        <Typography variant="caption" className="text-red-500 mt-1 block">
          {error}
        </Typography>
      )}
    </label>
  );
}
